// extracted by mini-css-extract-plugin
export var label = "_da-5";
export var slideContainer = "_da-0";
export var slider = "_da-1";
export var sliderLg = "_da-4";
export var sliderMd = "_da-3";
export var sliderSm = "_da-2";